module.exports = __webpack_public_path__ + "img/logo_yellow_white.3c58c671.svg";